import { LoadSignaturePreferenceCompleteAction, UpdateSignaturePreferenceCompleteAction } from './preference.actions'
import { createReducer, on } from '@ngrx/store'
import { initialState } from './preference.state'

export const reducer = createReducer(
  initialState,
  on(LoadSignaturePreferenceCompleteAction, (state, { preference }) => ({ ...state, preference, isLoaded: true })),
  on(UpdateSignaturePreferenceCompleteAction, (state, { preference }) => ({ ...state, preference }))
)
